import { FadeIn } from "@/components/FadeIn";
import { Lock } from "lucide-react";

const testimonials = [
  {
    text: "Ich wusste nicht, wo ich anfangen sollte. Der Entwurf war der ruhige Anker, an dem ich meine eigenen Worte gefunden habe.",
    by: "Tochter, 47",
  },
  {
    text: "Würdevoll formuliert. Kein Floskel-Sprech. Ich konnte vieles übernehmen und nur weniges anpassen.",
    by: "Trauerredner, 38",
  },
  {
    text: "Drei Tage vor der Beerdigung war ich blockiert. Dieses Werkzeug hat mir geholfen, klar zu denken.",
    by: "Sohn, 52",
  },
];

export default function Trust() {
  return (
    <section className="py-16 md:py-24 bg-parchment/40">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <FadeIn>
          <p className="label-eyebrow mb-6">Vertrauen & Ton</p>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-charcoal max-w-2xl leading-[1.1]">
            Stille Stimmen.
          </h2>
        </FadeIn>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          {testimonials.map((t, i) => (
            <FadeIn key={i} delay={i * 0.1}>
              <figure
                data-testid={`testimonial-${i}`}
                className="bg-paper rounded-2xl p-10 shadow-card h-full flex flex-col"
              >
                <blockquote className="font-serif italic text-lg text-charcoal leading-relaxed flex-1">
                  „{t.text}"
                </blockquote>
                <figcaption className="mt-8 font-display tracking-[0.25em] text-[10px] text-umber">
                  — {t.by}
                </figcaption>
              </figure>
            </FadeIn>
          ))}
        </div>

        <FadeIn delay={0.4}>
          <div className="mt-16 flex items-center justify-center gap-3 text-ink/80">
            <Lock className="w-4 h-4" strokeWidth={1.4} />
            <p className="font-sans text-sm">
              Diskrete Verarbeitung. Wir speichern keine personenbezogenen Inhalte langfristig.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
